import {
    InternalEmailLayout,
    dominioIntegrationRow,
    emailLink,
    escapeHtml,
    html,
    requesterSection
} from "../../../shared/email/internal-email-layout";

/**
 * E-mail interno de solicitação de mudança de plano (Grow/Downgrade).
 * `requester` é o usuário logado que fez a solicitação — o time comercial
 * precisa de nome e telefone para retornar o contato.
 */
export const TemplateChangePlan = ({ type, accounting, request, requester = {} }) =>
    InternalEmailLayout({
        eyebrow: `Solicitação de mudança de plano · ${type}`,
        title: `(${accounting.superLogicaId ?? "-"}) ${accounting.name ?? "-"}`,
        intro: `A contabilidade realizou uma solicitação de <strong style="color: #2e5573;">${escapeHtml(type)}</strong>.`,
        sections: [
            requesterSection(requester),
            {
                title: "Solicitação",
                rows: [
                    [`Motivo do ${type}`, request.change],
                    ["Informação acrescentada", request.information]
                ]
            },
            {
                title: "Contrato atual",
                rows: [
                    ["Plano", accounting.contract],
                    ["Qtd. de empresas", accounting.countCompany],
                    ["Status interno", accounting.internalStatus],
                    ["Status Superlógica", accounting.superlogicaStatus]
                ]
            },
            {
                title: "Dados da contabilidade",
                rows: [
                    ["Código da Nucont", accounting.superLogicaId],
                    ["Código no HubSpot", accounting.hubspotId],
                    dominioIntegrationRow(accounting.integrationsHealth),
                    ["E-mail financeiro", html(emailLink(accounting.financialEmail))],
                    ["Dono da venda", accounting.seller],
                    ["Data da venda", accounting.createdAt]
                ]
            }
        ]
    });
